import { FiCalendar, FiClock, FiScissors, FiUser, FiTrash2, FiEdit } from 'react-icons/fi';

const AppointmentList = ({ appointments, onEdit, onDelete }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold mb-6">Your Appointments</h3>
      
      {appointments.length === 0 ? (
        <div className="text-center py-8 text-gray-400">
          You don't have any upcoming appointments.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {appointments.map((appointment) => (
            <div key={appointment.id} className="bg-gray-800 rounded-lg p-4 border border-gray-700">
              <div className="flex justify-between items-start mb-3">
                <h4 className="text-lg font-medium flex items-center">
                  <FiScissors className="text-purple-400 mr-2" />
                  {appointment.service}
                </h4>
                <span className="bg-purple-900 text-purple-300 text-sm px-2 py-1 rounded">
                  {appointment.status || 'Confirmed'}
                </span>
              </div>
              
              <div className="space-y-2 text-gray-300">
                <div className="flex items-center">
                  <FiUser className="mr-2 text-gray-400" />
                  {appointment.stylist}
                </div>
                <div className="flex items-center">
                  <FiCalendar className="mr-2 text-gray-400" />
                  {new Date(appointment.date).toLocaleDateString('en-US', {
                    weekday: 'short',
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                  })}
                </div>
                <div className="flex items-center">
                  <FiClock className="mr-2 text-gray-400" />
                  {appointment.time}
                </div>
              </div>
              
              {appointment.notes && (
                <div className="mt-3 pt-3 border-t border-gray-700">
                  <p className="text-sm text-gray-400 italic">"{appointment.notes}"</p>
                </div>
              )}
              
              <div className="flex justify-end space-x-2 mt-4">
                {/* <button
                  onClick={() => onEdit(appointment)}
                  className="p-2 text-gray-400 hover:text-purple-400 transition"
                >
                  <FiEdit />
                </button>
                <button
                  onClick={() => onDelete(appointment.id)}
                  className="p-2 text-gray-400 hover:text-red-400 transition"
                >
                  <FiTrash2 />
                </button> */}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AppointmentList;